<template>
  <div>
    <SmartTitle class="mb-4 title-chip" heading="1" weight="medium">
      Rastreabilidade de APIs
    </SmartTitle>

    <!-- Component filter protocol_id -->
    <div
      class="
        main__wrapper
        bg-white
        flex
        align-center
        justify-around
        flex-row
        relative
      "
    >
      <div class="my-4 form-area">
        <form class="flex justify-between align-center">
          <div class="spacing-input-search">
            <div class="flex justify-end">
              <v-text-field
                v-model="search"
                label="Buscar por Protocolo"
                single-line
                hide-details
                name="search"
              />
              <button
                @click.prevent="findByProtocol"
                class="
                  flex
                  my-1
                  align-center
                  justify-center
                  rounded
                  absolute
                  bg-brand-secondary
                  cursor-pointer
                "
                style="width: 120px; height: 40px; color: white"
              >
                <SmartIcon
                  :size="2"
                  name="search"
                  color="white"
                  style="margin-right: 8px"
                />
                Buscar
              </button>
            </div>
          </div>
          <!-- Button Export Data -->
          <!-- <div class="spacing-button-download">
            <button
              @click="sendInfoToExport"
              class="
                flex
                my-1
                align-center
                justify-center
                cursor-pointer
                rounded
                absolute
              "
              style="width: 50px; height: 40px; color: white"
            >
              <SmartIcon
                :size="2"
                name="download"
                color="grey"
                style="
                  width: 40px;
                  height: 40px;
                  margin: 10px;
                  border-radius: 5px;
                  padding: 7px;
                "
                class="btn-download"
              />
            </button>
          </div> -->
        </form>
      </div>
    </div>

    <SmartCard class="mt-4 p-3" v-if="loading">
      <SmartSkeletonLoading :items="11" :height="4" />
    </SmartCard>

    <!-- Component info protocol_id -->
    <Protocol :items="itensList" v-if="!loading && itensList.length" />

    <div v-if="details.length">
      <SmartTitle class="mb-4 title-chip" heading="1" weight="medium"
        >Detalhes</SmartTitle
      >
      <Movimentation
        :details="details"
        :distributor="getDistributor()"
        v-if="checkType('MOVIMENTATION')"
      />
      <Capillarity :details="details" v-if="checkType('CAPILLARITY')" />
    </div>
    <SmartModal v-if="modal" v-bind="modal" @close="modal = null"
      >{{ modal.text }}
    </SmartModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { formatBRDateTime } from "utils/date";
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "ListTrakingApi",
  components: {
    Protocol: () => import("./protocol/Index"),
    Movimentation: () => import("./types/Movimentation"),
    Capillarity: () => import("./types/Capillarity"),
    Payload: () => import("./modal/Payload"),
  },
  mixins: [clickaway],
  data() {
    return {
      details: [],
      skeleton: false,
      modal: null,
      loading: false,
      search: "",
    };
  },
  computed: {
    ...mapGetters({
      tokenConfidenceSigtim: "tracking/tokenConfidenceSigtim",
      trackingList: "tracking/trackingList",
    }),
    itensList() {
      if (typeof this.trackingList[0] === "undefined") {
        return [];
      }
      return (
        (this.trackingList &&
          this.trackingList.map(
            (tracking) => (
              (this.details = tracking.proccess_details),
              {
                id: tracking ? tracking.id : "-",
                protocol: tracking ? tracking.protocol : "-",
                distributor: tracking ? tracking.distributor : "-",
                type: tracking ? tracking.type : "-",
                sub_type: tracking ? tracking.sub_type : "-",
                duration: tracking ? tracking.duration : "-",
                status: tracking ? tracking.status : "-",
                date_request: tracking
                  ? formatBRDateTime(tracking.date_request)
                  : "-",
                date_response: tracking
                  ? formatBRDateTime(tracking.date_response)
                  : "-",
                request: tracking ? tracking.request : "-",
                response: tracking ? tracking.response : "-",
                quantity_of_items: tracking ? tracking.quantity_of_items : "0",
                quantity_of_successes: tracking
                  ? tracking.quantity_of_successes
                  : "0",
                quantity_of_errors: tracking
                  ? tracking.quantity_of_errors
                  : "0",
              }
            )
          )) ||
        []
      );
    },
  },
  methods: {
    ...mapActions({
      fetchConfidenceSigtimLogin: "tracking/fetchConfidenceSigtimLogin",
      fetchTrackingListWithFilter: "tracking/fetchTrackingListWithFilter",
      fetchTrackingByProtocol: "tracking/fetchTrackingByProtocol",
      fetchExportProtocol: "tracking/fetchExportProtocol",
      setTrackingDefault: "tracking/setTrackingDefault"
    }),
    sendInfoToExport() {
      const ids = [];
      this.list.forEach((item) => ids.push(item.id));

      this.loadingCoverSheet = true;
      this.fetchExportProtocol({ ids: [...new Set(ids)] })
        .then((data) => {
          downloadXlsFile({ filename: "protocolo", file: data.data });
        })
        .catch((err) => {
          getBlobError(err);
        })
        .finally(() => {
          this.loadingCoverSheet = false;
        });
    },
    hideModal() {
      this.modal = false;
    },
    async findByProtocol() {
      const search = this.search.replace(/[.-]/g, "");

      this.skeleton = true;
      this.loading = true;
      this.details = [];
      this.list = [];

      await this.fetchTrackingByProtocol(search)
        .catch(() => {
          this.skeleton = true;
          this.loading = true;
          this.details = [];
          this.setTrackingDefault();
          this.showErrorModal();
        })
        .finally(() => {
          this.skeleton = false;
          this.loading = false;
        });
    },
    showErrorModal() {
      this.modal = {
        type: "warning",
        title: "Ops!",
        icon: "alert",
        buttonText: "Tentar novamente",
        text: "Protocolo id não encontrado.",
      };
    },
    close() {
      this.filterModal = false;
    },
    checkType(type) {
      return this.itensList[0].type === type;
    },
    getDistributor() {
      return this.itensList[0].distributor;
    }
  },
  async mounted() {
    this.loading = true;
    await this.fetchConfidenceSigtimLogin();
    this.list = [];
    this.details = [];
    this.loading = false;
    this.setTrackingDefault();
  },
};
</script>

<style lang="scss">
.v-input__control .v-input__slot .v-text-field__slot input {
  width: 270px;
}
.filter-modal {
  right: $spacing-margin-medium;
  box-shadow: $box-shadow-sm;
  z-index: 1;
}

.fix-right-on-filter-modal {
  right: inherit !important;
}

.main__wrapper {
  padding: 15px 15px 15px 15px;
  border: 1px solid #e3e5e6;
  border-radius: 6px;
  height: 70px;
  z-index: 1;
  margin-top: 20px;
}

.spacing-input-search {
  max-width: 100% !important;
  width: 93% !important;
}

.spacing-button-download {
  max-width: 100% !important;
  width: 5% !important;
  height: 70px;
  position: relative;
  border-left: 1px solid #e3e5e6;
}

.btn-download {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  border: 2px solid;
}

.form-area {
  width: 100%;
}

.title-chip {
  margin-left: 0rem;
}
</style>
